import { render } from "./SalePrint.vue?vue&type=template&id=89bb74e8&scoped=true"
import script from "./SalePrint.vue?vue&type=script&lang=js"
export * from "./SalePrint.vue?vue&type=script&lang=js"

import "./SalePrint.vue?vue&type=style&index=0&id=89bb74e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bb74e8"]])

export default __exports__